/* eslint-disable @next/next/no-img-element */
// Brand payment logos are static SVGs in public/ sized purely by CSS height; next/image
// would force fixed numeric dimensions per logo for no optimization benefit here.
import classNames from 'classnames';
import { ReactElement } from 'react';

interface PaymentMethod {
  src: string;
  alt: string;
}

const PAYMENT_METHODS: PaymentMethod[] = [
  { src: '/payments/przelewy24.svg', alt: 'Przelewy24' },
  { src: '/payments/blik.svg', alt: 'BLIK' },
  { src: '/payments/visa.svg', alt: 'Visa' },
  { src: '/payments/mastercard.svg', alt: 'Mastercard' },
  { src: '/payments/payu.svg', alt: 'PayU' },
  { src: '/payments/stripe.svg', alt: 'Stripe' }
];

export default function PaymentMethods({ className }: { className?: string }): ReactElement {
  return (
    <div
      className={classNames('flex flex-wrap items-center gap-xs', className)}
      role='group'
      aria-label='Obsługiwane metody płatności'
    >
      {PAYMENT_METHODS.map((method) => (
        <span
          key={method.alt}
          className='inline-flex items-center justify-center bg-white rounded-xs px-xs py-xxs'
        >
          <img
            src={method.src}
            alt={method.alt}
            loading='lazy'
            className='h-md w-auto object-contain'
          />
        </span>
      ))}
    </div>
  );
}
